import keys from '@debbie/common/dist/cache/keys.js';
import { CaseStatus, CaseTag, SystemEndReason, EndReasonId, } from '@debbie/common/dist/cases/index.js';
import { defaultMergeRules, RelationType, } from '@debbie/common/dist/customers/index.js';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { FeatureFlag } from '@debbie/common/dist/feature-flags/index.js';
import { Currency, Entity, validateEmail, } from '@debbie/common/dist/index.js';
import { InteractionType } from '@debbie/common/dist/interactions/index.js';
import { appliesToCaseGroup, } from '@debbie/common/dist/properties/index.js';
import { TemplateType, getTemplateTypeForInteractionType, } from '@debbie/common/dist/templates/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import { TodoType, TRIGGER_AGENT_PROMPT_MAX_LENGTH, } from '@debbie/common/dist/workflows/index.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { useAllCollectors } from '@debbie/cortex/dist/collectors/index.js';
import { useConnectConnectionsFrom } from '@debbie/cortex/dist/connect/index.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import q from '@debbie/cortex/dist/query.js';
import { templatesEntity, useTemplates, } from '@debbie/cortex/dist/templates/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { styled } from 'styled-components';
import { useVariation } from '../../feature-flags/index.js';
import { errorNotification } from '../../utils/errors.js';
import Button from '../Button.js';
import ButtonGroup from '../ButtonGroup.js';
import CaseGroupSelect from '../CaseGroupSelect.js';
import Checkbox from '../Checkbox.js';
import ExclusiveContent from '../ExclusiveContent.js';
import { X } from '../Icons/index.js';
import Input from '../Input.js';
import MergeCaseRules from '../MergeCaseRules.js';
import SearchInput from '../SearchInput.js';
import SearchResponsible from '../SearchResponsible.js';
import Select from '../Select.js';
import TagsEditor from '../TagsEditor.js';
import Textarea from '../Textarea.js';
import Well from '../Well.js';
const getTemplateTypeFromInteractionType = (interactionType) => {
    const templateType = getTemplateTypeForInteractionType(interactionType);
    if (!templateType) {
        throw new Error('Not handled interaction type in template/interaction map');
    }
    return templateType;
};
const ProcedureCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const hasAIEnabled = useVariation(FeatureFlag.AISuggestions);
    const templatesLoadable = useTemplates();
    const templates = h.hasData(templatesLoadable) ? templatesLoadable.data : null;
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : [];
    const collectorsLoadable = useAllCollectors();
    const collectors = h.hasData(collectorsLoadable)
        ? collectorsLoadable.data
        : null;
    const collectorsMap = (collectors &&
        objectBy(collectors, (collector) => collector.collectorId)) ||
        {};
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const workflowsLoadable = useWorkflows();
    const workflows = h.hasData(workflowsLoadable) ? workflowsLoadable.data : null;
    const fromConnections = useConnectConnectionsFrom();
    const endReasons = useEndReasons();
    const [selectableTemplates, setSelectableTemplates] = useState(null);
    const [todoType, setTodoType] = useState(TodoType.AddVoucher);
    const [caseVoucherTypeId, setCaseVoucherTypeId] = useState(VoucherTypeIds.REMINDERFEE);
    const [billingVoucherTypeId, setBillingVoucherTypeId] = useState(null);
    const [text, setText] = useState('');
    const [amount, setAmount] = useState('100');
    const [imposedByCreditor, setImposedByCreditor] = useState(false);
    const [interactionType, setInteractionType] = useState(InteractionType.Email);
    const [sendImmediatelyDeviateFromSettings, setSendImmediatelyDeviateFromSettings,] = useState(false);
    const [sendImmediately, setSendImmediately] = useState(undefined);
    const [creditorInteractionType, setCreditorInteractionType] = useState(InteractionType.Email);
    const [otherInteractionType, setOtherInteractionType] = useState(InteractionType.Email);
    const [to, setTo] = useState('');
    const [cc, setCC] = useState('');
    const [bcc, setBCC] = useState('');
    const [includeVoucherAttachments, setIncludeVoucherAttachments] = useState(true);
    const [includeFoundationAttachments, setIncludeFoundationAttachments] = useState(false);
    const [attachmentTemplateIds, setAttachmentTemplateIds] = useState([]);
    const [templateId, setTemplateId] = useState('');
    const [collectorId, setCollectorId] = useState(null);
    const [collector, setCollector] = useState('');
    const [caseGroupId, setCaseGroupId] = useState(null);
    const [caseTag, setCaseTag] = useState(CaseTag.SURVEILLANCE);
    const [endReasonId, setEndReasonId] = useState(EndReasonId[SystemEndReason.Paid]);
    const [endCaseIfThereIsNoPrincipalLeft, setEndCaseIfThereIsNoPrincipalLeft] = useState(true);
    const [useCreditorCollector, setUseCreditorCollector] = useState(false);
    const [setAsPrincipalReferenceCaseVoucher, setAsPrincipalreferenceVoucher] = useState(undefined);
    const [maxTotalAmount, setMaxTotalAmount] = useState(undefined);
    const [bespokeName, setBespokeName] = useState('');
    const [agentPrompt, setAgentPrompt] = useState('');
    const [toWorkflowId, setToWorkflowId] = useState(null);
    const [mergeWithRelatedCases, setMergeWithRelatedCases] = useState([]);
    const [customCaseMergeRules, setCustomCaseMergeRules] = useState(undefined);
    const [caseResponsible, setCaseResponsible] = useState(null);
    const [caseSettingKey, setCaseSettingKey] = useState(null);
    const [caseSettingValue, setCaseSettingValue] = useState(undefined);
    useEffect(() => {
        if (templates) {
            const templateTypeMap = {};
            for (let i = 0; i < templates.length; i++) {
                const template = templates[i];
                templateTypeMap[template.type] = {
                    ...templateTypeMap[template.type],
                    [template.templateId]: template.name,
                };
            }
            setSelectableTemplates(Object.entries(templateTypeMap).reduce((acc, [templateType, templateMap]) => {
                acc[templateType] = Object.entries(templateMap).map(([templateId, name]) => ({
                    templateId,
                    name,
                }));
                return acc;
            }, {}));
        }
    }, [templates]);
    const getTodo = (details) => ({
        id: crypto.randomUUID(),
        type: todoType,
        details,
    });
    const addMutation = useMutation(async (todoDetails) => {
        await props.onCreate(getTodo(todoDetails));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.procedure);
        },
    });
    const add = (todoDetails) => {
        addMutation.mutate(todoDetails);
    };
    const createTemplate = useMutation((name) => templatesAPI.create({
        name,
        type: getTemplateTypeFromInteractionType(interactionType),
        details: getTemplateTypeFromInteractionType(interactionType) ===
            TemplateType.AUTOCALL
            ? { actions: [] }
            : {},
    }), {
        onSuccess: (res) => {
            q.invalidate(keys.write.create(templatesEntity));
            setTemplateId(res.id);
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.template);
        },
    });
    const loading = addMutation.isLoading;
    const isExclusiveContent = me && exclusiveContent?.includes(me.id);
    const selectedCaseVoucherType = voucherTypes.find((vt) => vt.voucherTypeId === caseVoucherTypeId);
    const selectedBillingVoucherType = voucherTypes.find((vt) => vt.voucherTypeId === billingVoucherTypeId);
    return (React.createElement(ProcedureBuilderStyled, null,
        React.createElement(Select, { options: Object.values(TodoType)
                .filter((type) => {
                if (tenant?.type === TenantType.AccountsReceivable &&
                    [
                        TodoType.AddBillingVoucher,
                        TodoType.CreateCreditorInteraction,
                    ].includes(type)) {
                    return false;
                }
                if ([TodoType.MoveToTenant].includes(type)) {
                    return false;
                }
                if (type === TodoType.TriggerAgent && !hasAIEnabled) {
                    return false;
                }
                // TODO(fq): Replace with feature flag / setting
                if (tenant &&
                    [
                        '39ba5dbc-15b5-4cbd-80cd-90d7405ce066', // Kredinor
                        'f41515fd-7f88-4ff3-a152-8ffd2e2222ea', // Kredinor sandbox
                        '3d636747-ced9-4838-bf07-19f4324cd9e5', // Azets
                        '3657071d-fce5-43d8-95dd-6dd01e8ea5c1', // Azets sandbox
                    ].includes(tenant.id) &&
                    [TodoType.SetCollector].includes(type)) {
                    return true;
                }
                return isExclusiveContent
                    ? true
                    : ![TodoType.Bespoke, TodoType.SetCollector].includes(type);
            })
                .sort((a, b) => (lang.workflowTodoTypes[a] ?? '').localeCompare(lang.workflowTodoTypes[b] ?? ''))
                .map((type) => ({
                value: type,
                label: lang.workflowTodoTypes[type],
            })), selected: [todoType], onChange: (selected) => {
                const [value] = selected;
                if (value != null) {
                    setTodoType(value);
                    setTemplateId('');
                }
            } }),
        React.createElement(Well, null, (() => {
            switch (todoType) {
                case TodoType.AddVoucher:
                    return (React.createElement("div", null,
                        React.createElement(SearchInput, { forceOpen: true, placeholder: lang.voucherTypeSettings.caseVoucherType, onSelect: (voucherType) => {
                                if (voucherType.editorSettings.defaultAmount) {
                                    setAmount((voucherType.editorSettings.defaultAmount / 100).toString());
                                }
                                setCaseVoucherTypeId(voucherType.voucherTypeId);
                            }, searchAll: (q) => {
                                return (voucherTypes || [])
                                    .filter((voucherType) => {
                                    if (![
                                        VoucherCategory.COST,
                                        VoucherCategory.COURTCOST,
                                        VoucherCategory.PRINCIPAL,
                                        VoucherCategory.INTEREST,
                                    ].includes(voucherType.category)) {
                                        return false;
                                    }
                                    if (voucherType.category === VoucherCategory.INTEREST &&
                                        ![
                                            VoucherTypeIds.PROCESSINTEREST,
                                            VoucherTypeIds.GLPROCESSINTEREST,
                                        ].includes(voucherType.voucherTypeId)) {
                                        return false;
                                    }
                                    return (`${lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label}${JSON.stringify(voucherType)}`
                                        .toLowerCase()
                                        .indexOf(q.toLowerCase()) !== -1 || q.length === 0);
                                })
                                    .map((voucherType) => ({
                                    key: voucherType.voucherTypeId,
                                    heading: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label,
                                    subheading: lang.economyCategories[voucherType.category],
                                    returnData: voucherType,
                                }));
                            }, static: selectedCaseVoucherType
                                ? lang.economyVoucherTypeLabels[selectedCaseVoucherType.voucherTypeId] || selectedCaseVoucherType.label
                                : null, onRemoveStatic: () => setCaseVoucherTypeId(null) }),
                        caseVoucherTypeId &&
                            ![
                                VoucherTypeIds.GLPROCESSINTEREST,
                                VoucherTypeIds.PROCESSINTEREST,
                                VoucherTypeIds.COLLECTIONCOST,
                            ].includes(caseVoucherTypeId) && (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: amount, type: "number", onChange: (e) => {
                                    setAmount(e.target.value);
                                }, placeholder: lang.workflows.amount }),
                            React.createElement(Checkbox, { placeholder: lang.workflows.setMaxTotalAmount, onChange: (e) => {
                                    setMaxTotalAmount(e.target.checked ? '300' : undefined);
                                } }),
                            maxTotalAmount !== undefined && (React.createElement(Input, { value: maxTotalAmount, type: "number", onChange: (e) => {
                                    setMaxTotalAmount(e.target.value);
                                }, placeholder: lang.workflows.maxTotalAmount })))),
                        caseVoucherTypeId &&
                            ![
                                VoucherTypeIds.GLPROCESSINTEREST,
                                VoucherTypeIds.PROCESSINTEREST,
                            ].includes(caseVoucherTypeId) && (React.createElement(Checkbox, { placeholder: lang.workflows.setAsPrincipalReferenceCaseVoucher, checked: setAsPrincipalReferenceCaseVoucher, onChange: (e) => {
                                setAsPrincipalreferenceVoucher(e.target.checked ? true : undefined);
                            } })),
                        React.createElement(Checkbox, { placeholder: lang.workflows.imposedByCreditor, checked: imposedByCreditor, onChange: (e) => {
                                setImposedByCreditor(e.target.checked);
                            } }),
                        React.createElement(Button, { loading: loading, disabled: !caseVoucherTypeId, onClick: () => add({
                                voucherTypeId: caseVoucherTypeId,
                                currency: (tenant && tenant.currency) || Currency.DKK,
                                imposedByCreditor,
                                setAsPrincipalReferenceCaseVoucher,
                                maxTotalAmount: maxTotalAmount &&
                                    caseVoucherTypeId &&
                                    ![
                                        VoucherTypeIds.GLPROCESSINTEREST,
                                        VoucherTypeIds.PROCESSINTEREST,
                                        VoucherTypeIds.COLLECTIONCOST,
                                    ].includes(caseVoucherTypeId) &&
                                    Math.round(parseFloat(maxTotalAmount) * 100),
                                amount: caseVoucherTypeId &&
                                    ![
                                        VoucherTypeIds.GLPROCESSINTEREST,
                                        VoucherTypeIds.PROCESSINTEREST,
                                        VoucherTypeIds.COLLECTIONCOST,
                                    ].includes(caseVoucherTypeId) &&
                                    Math.round(parseFloat(amount) * 100),
                            }) }, lang.workflows.addTodo)));
                case TodoType.AddBillingVoucher:
                    return (React.createElement("div", null,
                        React.createElement(SearchInput, { forceOpen: true, placeholder: lang.voucherTypeSettings.caseVoucherType, onSelect: (voucherType) => {
                                setBillingVoucherTypeId(voucherType.voucherTypeId);
                            }, searchAll: (q) => {
                                return (voucherTypes || [])
                                    .filter((voucherType) => {
                                    if (![
                                        VoucherCategory.FEE,
                                        VoucherCategory.DISBURSEMENT,
                                    ].includes(voucherType.category)) {
                                        return false;
                                    }
                                    return (`${lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label}${JSON.stringify(voucherType)}`
                                        .toLowerCase()
                                        .indexOf(q.toLowerCase()) !== -1 || q.length === 0);
                                })
                                    .map((voucherType) => ({
                                    key: voucherType.voucherTypeId,
                                    heading: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label,
                                    subheading: lang.economyCategories[voucherType.category],
                                    returnData: voucherType,
                                }));
                            }, static: selectedBillingVoucherType
                                ? lang.economyVoucherTypeLabels[selectedBillingVoucherType.voucherTypeId] || selectedBillingVoucherType.label
                                : null, onRemoveStatic: () => setBillingVoucherTypeId(null) }),
                        React.createElement(Input, { value: amount, type: "number", onChange: (e) => {
                                setAmount(e.target.value);
                            }, placeholder: lang.workflows.amount }),
                        React.createElement(Input, { placeholder: lang.workflows.text, value: text, onChange: (e) => {
                                setText(e.target.value);
                            } }),
                        React.createElement(Button, { loading: loading, disabled: !billingVoucherTypeId, onClick: () => add({
                                voucherTypeId: billingVoucherTypeId,
                                currency: (tenant && tenant.currency) || Currency.DKK,
                                text: text || null,
                                amount: Math.round(parseFloat(amount) * 100),
                            }) }, lang.workflows.addTodo)));
                case TodoType.RemoveVoucher:
                    return (React.createElement("div", null,
                        React.createElement(SearchInput, { forceOpen: true, placeholder: lang.voucherTypeSettings.caseVoucherType, onSelect: (voucherType) => {
                                setCaseVoucherTypeId(voucherType.voucherTypeId);
                            }, searchAll: (q) => {
                                return (voucherTypes || [])
                                    .filter((voucherType) => {
                                    if (![
                                        VoucherCategory.COST,
                                        VoucherCategory.COURTCOST,
                                        VoucherCategory.PRINCIPAL,
                                        VoucherCategory.INTEREST,
                                    ].includes(voucherType.category)) {
                                        return false;
                                    }
                                    return (`${lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label}${JSON.stringify(voucherType)}`
                                        .toLowerCase()
                                        .indexOf(q.toLowerCase()) !== -1 || q.length === 0);
                                })
                                    .map((voucherType) => ({
                                    key: voucherType.voucherTypeId,
                                    heading: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label,
                                    subheading: lang.economyCategories[voucherType.category],
                                    returnData: voucherType,
                                }));
                            }, static: selectedCaseVoucherType
                                ? lang.economyVoucherTypeLabels[selectedCaseVoucherType.voucherTypeId] || selectedCaseVoucherType.label
                                : null, onRemoveStatic: () => setCaseVoucherTypeId(null) }),
                        React.createElement(Button, { loading: loading, onClick: () => add({
                                voucherTypeId: caseVoucherTypeId,
                            }), disabled: !caseVoucherTypeId }, lang.workflows.addTodo)));
                case TodoType.CreateInteraction:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: interactionType, onChange: (e) => {
                                setInteractionType(e.target.value);
                                setTemplateId('');
                            } }, [
                            InteractionType.Email,
                            InteractionType.DebtorNote,
                            InteractionType.Letter,
                            InteractionType.SMS,
                            InteractionType.AutoCall,
                            InteractionType.Eboks,
                            InteractionType.EInvoice,
                            InteractionType.Kivra,
                            InteractionType.Digipost,
                            InteractionType.Note,
                        ]
                            .filter((type) => {
                            return isExclusiveContent
                                ? true
                                : ![
                                    InteractionType.Kivra,
                                    InteractionType.Digipost,
                                ].includes(type);
                        })
                            .map((interactionType) => (React.createElement("option", { key: interactionType, value: interactionType }, lang.interactionTypes[interactionType])))),
                        interactionType !== InteractionType.EInvoice && (React.createElement(SearchInput, { loading: createTemplate.isLoading, searchAll: (q) => {
                                const results = ((selectableTemplates &&
                                    selectableTemplates[getTemplateTypeFromInteractionType(interactionType)] &&
                                    selectableTemplates[getTemplateTypeFromInteractionType(interactionType)].filter((_template) => !q ||
                                        JSON.stringify(_template)
                                            .toLocaleLowerCase()
                                            .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                    []).map((_template) => ({
                                    heading: _template.name,
                                    key: _template.templateId,
                                    returnData: { templateId: _template.templateId },
                                }));
                                if (results.length === 0 && q.length > 3) {
                                    results.push({
                                        heading: `${lang.workflows.addNewTemplate}: ${q}`,
                                        subheading: lang.workflows.addNewTemplateSubheading,
                                        key: 'no-template-found',
                                        returnData: {
                                            newTemplate: true,
                                            name: q,
                                        },
                                    });
                                }
                                return results;
                            }, onSelect: (_template) => {
                                if (_template.newTemplate && _template.name) {
                                    createTemplate.mutate(_template.name);
                                }
                                else if (_template.templateId) {
                                    setTemplateId(_template.templateId);
                                }
                            }, cacheResetTrigger: interactionType, static: templateId &&
                                (() => {
                                    const _templates = selectableTemplates &&
                                        selectableTemplates[getTemplateTypeFromInteractionType(interactionType)];
                                    const template = _templates &&
                                        _templates.find((t) => t.templateId === templateId);
                                    return template ? template.name : templateId;
                                })(), onRemoveStatic: () => {
                                setTemplateId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectTemplate })),
                        [
                            InteractionType.Email,
                            InteractionType.Letter,
                            InteractionType.Eboks,
                        ].includes(interactionType) && (React.createElement("div", null,
                            React.createElement(Checkbox, { checked: includeVoucherAttachments, onChange: (e) => {
                                    setIncludeVoucherAttachments(e.target.checked);
                                }, placeholder: lang.workflows.includeVoucherAttachments }),
                            tenant?.type === TenantType.Agency && (React.createElement(Checkbox, { checked: includeFoundationAttachments, onChange: (e) => {
                                    setIncludeFoundationAttachments(e.target.checked);
                                }, placeholder: lang.workflows.attachFoundations })),
                            React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                    selectableTemplates.letter &&
                                    selectableTemplates.letter.filter((_template) => !q ||
                                        JSON.stringify(_template)
                                            .toLocaleLowerCase()
                                            .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                    []).map((_template) => ({
                                    heading: _template.name,
                                    key: _template.templateId,
                                    returnData: _template.templateId,
                                })), cacheResetTrigger: interactionType, onSelect: (_templateId) => {
                                    setAttachmentTemplateIds(attachmentTemplateIds.concat(_templateId));
                                }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectEmailPDFAttachment }),
                            React.createElement("div", null, attachmentTemplateIds.map((_templateId, i) => {
                                const template = selectableTemplates &&
                                    selectableTemplates.letter.find((t) => t.templateId === _templateId);
                                return (React.createElement("p", { key: _templateId, style: { margin: '0 0 1em 0' } },
                                    i + 1,
                                    ")",
                                    ' ',
                                    React.createElement("b", null, template ? template.name : _templateId),
                                    React.createElement(X, { onClick: () => {
                                            setAttachmentTemplateIds(attachmentTemplateIds.filter((_, index) => i !== index));
                                        }, style: {
                                            float: 'right',
                                            cursor: 'pointer',
                                        } })));
                            })))),
                        React.createElement(Checkbox, { placeholder: lang.workflows.sendImmediatelyDeviateFromSettings, checked: sendImmediatelyDeviateFromSettings, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setSendImmediately(true);
                                }
                                else {
                                    setSendImmediately(undefined);
                                }
                                setSendImmediatelyDeviateFromSettings(checked);
                            } }),
                        sendImmediatelyDeviateFromSettings && (React.createElement("div", null,
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "mini", theme: !sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(true);
                                    } }, lang.workflows.sendImmediately),
                                React.createElement(Button, { size: "mini", theme: sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(false);
                                    } }, lang.workflows.doNotSendImmediately)),
                            React.createElement("br", null),
                            React.createElement("br", null))),
                        React.createElement(Button, { loading: loading, disabled: !(interactionType === InteractionType.EInvoice ||
                                templateId), onClick: () => add({
                                type: interactionType,
                                templateId,
                                attachFoundations: includeFoundationAttachments,
                                includeVoucherAttachments: interactionType === InteractionType.Email &&
                                    includeVoucherAttachments,
                                attachments: interactionType === InteractionType.Email &&
                                    attachmentTemplateIds.map((id) => ({
                                        templateId: id,
                                    })),
                                sendImmediately,
                            }) }, lang.workflows.addTodo)));
                case TodoType.CreateCreditorInteraction:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: creditorInteractionType, onChange: (e) => {
                                setCreditorInteractionType(e.target.value);
                            } }, [InteractionType.ClientNote, InteractionType.Email].map((_interactionType) => (React.createElement("option", { key: _interactionType, value: _interactionType }, lang.interactionTypes[_interactionType])))),
                        React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                selectableTemplates[getTemplateTypeFromInteractionType(creditorInteractionType)] &&
                                selectableTemplates[getTemplateTypeFromInteractionType(creditorInteractionType)].filter((_template) => !q ||
                                    JSON.stringify(_template)
                                        .toLocaleLowerCase()
                                        .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                []).map((_template) => ({
                                heading: _template.name,
                                key: _template.templateId,
                                returnData: _template.templateId,
                            })), onSelect: (_templateId) => {
                                setTemplateId(_templateId);
                            }, cacheResetTrigger: creditorInteractionType, static: templateId &&
                                (() => {
                                    const _templates = selectableTemplates &&
                                        selectableTemplates[getTemplateTypeFromInteractionType(creditorInteractionType)];
                                    const template = _templates &&
                                        _templates.find((t) => t.templateId === templateId);
                                    return template ? template.name : templateId;
                                })(), onRemoveStatic: () => {
                                setTemplateId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectTemplate }),
                        [
                            InteractionType.Email,
                            InteractionType.Letter,
                            InteractionType.Eboks,
                        ].includes(creditorInteractionType) && (React.createElement("div", null,
                            React.createElement(Checkbox, { checked: includeVoucherAttachments, onChange: (e) => {
                                    setIncludeVoucherAttachments(e.target.checked);
                                }, placeholder: lang.workflows.includeVoucherAttachments }),
                            tenant?.type === TenantType.Agency && (React.createElement(Checkbox, { checked: includeFoundationAttachments, onChange: (e) => {
                                    setIncludeFoundationAttachments(e.target.checked);
                                }, placeholder: lang.workflows.attachFoundations })),
                            React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                    selectableTemplates.letter &&
                                    selectableTemplates.letter.filter((_template) => !q ||
                                        JSON.stringify(_template)
                                            .toLocaleLowerCase()
                                            .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                    []).map((_template) => ({
                                    heading: _template.name,
                                    key: _template.templateId,
                                    returnData: _template.templateId,
                                })), cacheResetTrigger: creditorInteractionType, onSelect: (_templateId) => {
                                    setAttachmentTemplateIds(attachmentTemplateIds.concat(_templateId));
                                }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectEmailPDFAttachment }),
                            React.createElement("div", null, attachmentTemplateIds.map((_templateId, i) => {
                                const template = selectableTemplates &&
                                    selectableTemplates.letter.find((t) => t.templateId === _templateId);
                                return (React.createElement("p", { key: _templateId, style: { margin: '0 0 1em 0' } },
                                    i + 1,
                                    ")",
                                    ' ',
                                    React.createElement("b", null, template ? template.name : _templateId),
                                    React.createElement(X, { onClick: () => {
                                            setAttachmentTemplateIds(attachmentTemplateIds.filter((_, index) => i !== index));
                                        }, style: {
                                            float: 'right',
                                            cursor: 'pointer',
                                        } })));
                            })))),
                        React.createElement(Checkbox, { placeholder: lang.workflows.sendImmediatelyDeviateFromSettings, checked: sendImmediatelyDeviateFromSettings, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setSendImmediately(true);
                                }
                                else {
                                    setSendImmediately(undefined);
                                }
                                setSendImmediatelyDeviateFromSettings(checked);
                            } }),
                        sendImmediatelyDeviateFromSettings && (React.createElement("div", null,
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "mini", theme: !sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(true);
                                    } }, lang.workflows.sendImmediately),
                                React.createElement(Button, { size: "mini", theme: sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(false);
                                    } }, lang.workflows.doNotSendImmediately)),
                            React.createElement("br", null),
                            React.createElement("br", null))),
                        React.createElement(Button, { loading: loading, disabled: !templateId, onClick: () => add({
                                type: creditorInteractionType,
                                templateId,
                                attachFoundations: includeFoundationAttachments,
                                includeVoucherAttachments: creditorInteractionType === InteractionType.Email &&
                                    includeVoucherAttachments,
                                attachments: creditorInteractionType === InteractionType.Email &&
                                    attachmentTemplateIds.map((id) => ({
                                        templateId: id,
                                    })),
                                sendImmediately,
                            }) }, lang.workflows.addTodo)));
                case TodoType.CreateOtherInteraction:
                    return (React.createElement("div", null,
                        React.createElement(Input, { placeholder: "To", required: true, validationErrors: to ? (validateEmail(to) ? [] : ['!']) : undefined, value: to, onChange: (e) => setTo(e.target.value) }),
                        React.createElement(Input, { placeholder: "CC", value: cc, onChange: (e) => setCC(e.target.value) }),
                        React.createElement(Input, { placeholder: "BCC", value: bcc, onChange: (e) => setBCC(e.target.value) }),
                        React.createElement(Select, { value: otherInteractionType, onChange: (e) => {
                                setOtherInteractionType(e.target.value);
                            } }, [InteractionType.Email].map((_interactionType) => (React.createElement("option", { key: _interactionType, value: _interactionType }, lang.interactionTypes[_interactionType])))),
                        React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                selectableTemplates[getTemplateTypeFromInteractionType(interactionType)] &&
                                selectableTemplates[getTemplateTypeFromInteractionType(interactionType)].filter((_template) => !q ||
                                    JSON.stringify(_template)
                                        .toLocaleLowerCase()
                                        .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                []).map((_template) => ({
                                heading: _template.name,
                                key: _template.templateId,
                                returnData: _template.templateId,
                            })), onSelect: (_templateId) => {
                                setTemplateId(_templateId);
                            }, cacheResetTrigger: interactionType, static: templateId &&
                                (() => {
                                    const _templates = selectableTemplates &&
                                        selectableTemplates[getTemplateTypeFromInteractionType(interactionType)];
                                    const template = _templates &&
                                        _templates.find((t) => t.templateId === templateId);
                                    return template ? template.name : templateId;
                                })(), onRemoveStatic: () => {
                                setTemplateId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectTemplate }),
                        [
                            InteractionType.Email,
                            InteractionType.Letter,
                            InteractionType.Eboks,
                        ].includes(interactionType) && (React.createElement("div", null,
                            React.createElement(Checkbox, { checked: includeVoucherAttachments, onChange: (e) => {
                                    setIncludeVoucherAttachments(e.target.checked);
                                }, placeholder: lang.workflows.includeVoucherAttachments }),
                            tenant?.type === TenantType.Agency && (React.createElement(Checkbox, { checked: includeFoundationAttachments, onChange: (e) => {
                                    setIncludeFoundationAttachments(e.target.checked);
                                }, placeholder: lang.workflows.attachFoundations })),
                            React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                    selectableTemplates.letter &&
                                    selectableTemplates.letter.filter((_template) => !q ||
                                        JSON.stringify(_template)
                                            .toLocaleLowerCase()
                                            .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                    []).map((_template) => ({
                                    heading: _template.name,
                                    key: _template.templateId,
                                    returnData: _template.templateId,
                                })), cacheResetTrigger: interactionType, onSelect: (_templateId) => {
                                    setAttachmentTemplateIds(attachmentTemplateIds.concat(_templateId));
                                }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectEmailPDFAttachment }),
                            React.createElement("div", null, attachmentTemplateIds.map((_templateId, i) => {
                                const template = selectableTemplates &&
                                    selectableTemplates.letter.find((t) => t.templateId === _templateId);
                                return (React.createElement("p", { key: _templateId, style: { margin: '0 0 1em 0' } },
                                    i + 1,
                                    ")",
                                    ' ',
                                    React.createElement("b", null, template ? template.name : _templateId),
                                    React.createElement(X, { onClick: () => {
                                            setAttachmentTemplateIds(attachmentTemplateIds.filter((_, index) => i !== index));
                                        }, style: {
                                            float: 'right',
                                            cursor: 'pointer',
                                        } })));
                            })))),
                        React.createElement(Checkbox, { placeholder: lang.workflows.sendImmediatelyDeviateFromSettings, checked: sendImmediatelyDeviateFromSettings, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setSendImmediately(true);
                                }
                                else {
                                    setSendImmediately(undefined);
                                }
                                setSendImmediatelyDeviateFromSettings(checked);
                            } }),
                        sendImmediatelyDeviateFromSettings && (React.createElement("div", null,
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "mini", theme: !sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(true);
                                    } }, lang.workflows.sendImmediately),
                                React.createElement(Button, { size: "mini", theme: sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(false);
                                    } }, lang.workflows.doNotSendImmediately)),
                            React.createElement("br", null),
                            React.createElement("br", null))),
                        React.createElement(Button, { loading: loading, disabled: !(templateId && to && validateEmail(to)), onClick: () => add({
                                type: creditorInteractionType,
                                templateId,
                                attachFoundations: includeFoundationAttachments,
                                includeVoucherAttachments: interactionType === InteractionType.Email &&
                                    includeVoucherAttachments,
                                attachments: interactionType === InteractionType.Email &&
                                    attachmentTemplateIds.map((id) => ({
                                        templateId: id,
                                    })),
                                sendImmediately,
                                to,
                                cc,
                                bcc,
                            }) }, lang.workflows.addTodo)));
                case TodoType.SetCollector:
                    return (React.createElement("div", null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.useCreditorCollector, onChange: (e) => {
                                setUseCreditorCollector(e.target.checked);
                                setCollectorId('');
                            }, checked: useCreditorCollector }),
                        React.createElement(SearchInput, { searchAll: (q) => (collectors || [])
                                .filter((collector) => !q ||
                                JSON.stringify(collector)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)
                                .map((_collector) => ({
                                heading: _collector.name,
                                subheading: `${lang.collectorTypes[_collector.type]}${_collector.email ? ` - ${_collector.email}` : ''}`,
                                key: _collector.collectorId,
                                returnData: _collector.collectorId,
                            })), cacheResetTrigger: todoType, disabled: useCreditorCollector, onSelect: (_collectorId) => {
                                setCollectorId(_collectorId);
                            }, static: collectorId &&
                                (() => {
                                    const collector = collectorsMap[collectorId];
                                    return collector
                                        ? `${collector.name} (${lang.collectorTypes[collector.type]}${collector.email ? ` - ${collector.email}` : ''})`
                                        : collectorId;
                                })(), onRemoveStatic: () => {
                                setCollectorId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectCollector }),
                        React.createElement(Button, { loading: loading, disabled: !collectorId && !useCreditorCollector, onClick: () => add({
                                collectorId,
                                useCreditor: useCreditorCollector || undefined,
                            }) }, lang.workflows.addTodo)));
                case TodoType.SetCaseGroup:
                    return (React.createElement("div", null,
                        React.createElement(CaseGroupSelect, { placeholder: lang.workflows.selectCaseGroup, value: caseGroupId, onChange: setCaseGroupId }),
                        React.createElement(Button, { loading: loading, onClick: () => add({
                                caseGroupId,
                            }) }, lang.workflows.addTodo)));
                case TodoType.ConnectToDebtCollector:
                    return (React.createElement("div", null,
                        React.createElement(Select, { onChange: (e) => {
                                setCollector(e.target.value);
                            }, value: collector },
                            React.createElement("option", null, "-- V\u00E6lg inddriver --"),
                            h.hasData(fromConnections)
                                ? fromConnections.data.map((conn) => {
                                    return (React.createElement("option", { key: conn.id, value: conn.id }, conn.product.name));
                                })
                                : null),
                        React.createElement(Button, { loading: loading, disabled: !collector, onClick: () => add({
                                connectionId: collector,
                            }) }, lang.workflows.addTodo)));
                case TodoType.SetCaseTag:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(TagsEditor, { tags: caseTag
                                ? [
                                    {
                                        tag: caseTag,
                                    },
                                ]
                                : [], onChange: (tags) => {
                                setCaseTag(tags[0]?.tag || null);
                            }, availableTags: [CaseTag.SURVEILLANCE], translations: lang.caseTags, single: true }),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(Button, { loading: loading, disabled: !caseTag, onClick: () => add({
                                tag: caseTag,
                            }) }, lang.workflows.addTodo)));
                case TodoType.RemoveCaseTag:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(TagsEditor, { tags: caseTag
                                ? [
                                    {
                                        tag: caseTag,
                                    },
                                ]
                                : [], onChange: (tags) => {
                                setCaseTag(tags[0]?.tag || null);
                            }, availableTags: [CaseTag.SURVEILLANCE], translations: lang.caseTags, single: true }),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(Button, { loading: loading, disabled: !caseTag, onClick: () => add({
                                tag: caseTag,
                            }) }, lang.workflows.addTodo)));
                case TodoType.ChangeCaseStatus:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Select, { value: endReasonId, onChange: (e) => {
                                setEndReasonId(e.target.value);
                            } }, (h.hasData(endReasons) ? endReasons.data : []).map((reason) => (React.createElement("option", { key: reason.id, value: reason.id }, lang.endReason[reason.handle] ??
                            reason.label)))),
                        React.createElement(Button, { loading: loading, disabled: !caseTag, onClick: () => add({
                                status: CaseStatus.ENDED,
                                endReasonId,
                            }) }, lang.workflows.addTodo)));
                case TodoType.SwitchWorkflow:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(SearchInput, { searchAll: (q) => (workflows || [])
                                .filter((workflow) => !q ||
                                JSON.stringify(workflow)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)
                                .map((_workflow) => ({
                                heading: _workflow.title,
                                subheading: _workflow.description,
                                key: _workflow.workflowId,
                                returnData: _workflow.workflowId,
                            })), cacheResetTrigger: todoType, onSelect: (_workflowId) => {
                                setToWorkflowId(_workflowId);
                            }, static: toWorkflowId &&
                                (() => {
                                    const workflow = workflows?.find((workflow) => workflow.workflowId === toWorkflowId);
                                    return workflow ? workflow.title : toWorkflowId;
                                })(), onRemoveStatic: () => {
                                setToWorkflowId(null);
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.workflows }),
                        React.createElement(Button, { loading: loading, disabled: !toWorkflowId, onClick: () => {
                                add({
                                    toWorkflowId,
                                });
                                setToWorkflowId(null);
                            } }, lang.workflows.addTodo)));
                case TodoType.SwitchBackToPreviousWorkflow:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Button, { loading: loading, onClick: () => add({}) }, lang.workflows.addTodo)));
                case TodoType.MergeCase:
                    return (React.createElement(React.Fragment, null,
                        React.createElement("p", null, lang.workflows.mergeCaseTodoDescription),
                        React.createElement(ReactSelect, { value: mergeWithRelatedCases.map((relationType) => {
                                return {
                                    label: lang.customerCaseRelationType[relationType],
                                    value: relationType,
                                };
                            }), isMulti: true, placeholder: lang.workflows.mergeWithRelatedCasesOfType, classNamePrefix: "select", options: Object.values(RelationType).map((relationType) => {
                                return {
                                    label: lang.customerCaseRelationType[relationType],
                                    value: relationType,
                                };
                            }), onChange: (val) => {
                                const selected = val ? val.map((v) => v.value) : [];
                                setMergeWithRelatedCases(selected);
                            } }),
                        React.createElement("br", null),
                        React.createElement(Checkbox, { placeholder: lang.workflows.applyCustomMergeRules, checked: !!customCaseMergeRules, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setCustomCaseMergeRules(defaultMergeRules);
                                }
                                else {
                                    setCustomCaseMergeRules(undefined);
                                }
                            } }),
                        !!customCaseMergeRules && (React.createElement(MergeCaseRules, { onChange: (mergeRules) => setCustomCaseMergeRules(mergeRules), rules: customCaseMergeRules })),
                        React.createElement("br", null),
                        React.createElement(Button, { loading: loading, onClick: () => {
                                add({
                                    mergeWithRelatedCases,
                                    caseMergeRules: customCaseMergeRules,
                                });
                                setCustomCaseMergeRules(undefined);
                            } }, lang.workflows.addTodo)));
                case TodoType.CreateProperties: {
                    return (React.createElement(CreateProperties, { loading: loading, add: add }));
                }
                case TodoType.SetResponsible: {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(SearchResponsible, { onChange: (change) => {
                                console.log('Change responsible', change);
                                setCaseResponsible(change);
                            }, responsible: caseResponsible }),
                        React.createElement("br", null),
                        React.createElement(Button, { loading: loading, onClick: () => {
                                add(caseResponsible);
                                setCaseResponsible(null);
                            } }, lang.workflows.addTodo)));
                }
                case TodoType.MarkExpired: {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.endCaseIfThereIsNoPrincipalLeft, checked: endCaseIfThereIsNoPrincipalLeft, onChange: (e) => setEndCaseIfThereIsNoPrincipalLeft(e.target.checked) }),
                        React.createElement("label", null,
                            lang.workflows.endCaseReason,
                            React.createElement(Select, { value: endReasonId, onChange: (e) => {
                                    setEndReasonId(e.target.value);
                                } }, (h.hasData(endReasons) ? endReasons.data : []).map((reason) => (React.createElement("option", { key: reason.id, value: reason.id }, lang.endReason[reason.handle] ??
                                reason.label))))),
                        React.createElement(Button, { loading: loading, onClick: () => {
                                add({
                                    endReasonId,
                                    endCaseIfThereIsNoPrincipalLeft,
                                });
                            } }, lang.workflows.addTodo)));
                }
                case TodoType.SetCaseSetting: {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Select, { value: caseSettingKey, onChange: (e) => {
                                setCaseSettingKey(e.target.value);
                            } },
                            React.createElement("option", { value: "" },
                                "--- ",
                                lang.procedures.selectSetting,
                                " ---"),
                            Object.keys(lang.cases.caseSettings).map((key) => (React.createElement("option", { key: key, value: key }, lang.cases.caseSettings[key])))),
                        caseSettingKey && (React.createElement(React.Fragment, null,
                            caseSettingKey === 'disableDebtorPaymentPlan' && (React.createElement(Checkbox, { placeholder: lang.cases.caseSettings[caseSettingKey], checked: !!caseSettingValue, onChange: (e) => {
                                    setCaseSettingValue(e.target.checked);
                                } })),
                            React.createElement(Button, { loading: loading, onClick: () => add({
                                    key: caseSettingKey,
                                    value: !!caseSettingValue,
                                }) }, lang.workflows.addTodo)))));
                }
                case TodoType.Bespoke:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Input, { placeholder: "Name", value: bespokeName, onChange: (e) => {
                                setBespokeName(e.target.value);
                            } }),
                        React.createElement(Button, { loading: loading, disabled: !bespokeName, onClick: () => add({
                                name: bespokeName,
                            }) }, lang.workflows.addTodo)));
                case TodoType.TriggerAgent:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Textarea, { placeholder: lang.workflows.triggerAgent.promptPlaceholder, value: agentPrompt, onChange: (e) => setAgentPrompt(e.target.value), style: { minHeight: 120 } }),
                        React.createElement(Button, { loading: loading, disabled: agentPrompt.trim().length === 0 ||
                                agentPrompt.length > TRIGGER_AGENT_PROMPT_MAX_LENGTH, onClick: () => add({ prompt: agentPrompt.trim() }) }, lang.workflows.addTodo)));
                default:
                    return (React.createElement(Button, { loading: loading, onClick: () => add({}) }, lang.workflows.addTodo));
            }
        })())));
};
export default ProcedureCreator;
const ProcedureBuilderStyled = styled.div `
  text-align: left;

  & > h3 {
    font-size: 14px;
    margin-top: 0.5em;
  }
`;
const CreateProperties = (props) => {
    const lang = useSelector((s) => s.lang);
    const [propertyRef, setPropertyRef] = useState(Entity.CaseVoucher);
    const [caseGroupId, setCaseGroupId] = useState(null);
    const propertyTypesLoader = usePropertyTypes();
    const [overwrite, setOverWrite] = useState(false);
    const [propertyId, setPropertyId] = useState('');
    const [value, setValue] = useState('NOW()');
    const [filter, setFilter] = useState({
        type: 'category',
        voucherCategory: VoucherCategory.PRINCIPAL,
    });
    return (React.createElement(ExclusiveContent, { fallback: () => React.createElement("p", null, "Coming soon") },
        React.createElement(Select, { value: propertyRef, onChange: (e) => {
                setPropertyRef(e.currentTarget.value);
                setPropertyId('');
            } },
            React.createElement("option", { value: Entity.Customer }, lang.entities[Entity.Customer]),
            React.createElement("option", { key: "case", value: "case" }, "Case"),
            React.createElement("option", { key: "case-voucher", value: "case-voucher" }, "Case vouchers")),
        propertyRef !== Entity.Customer && (React.createElement(CaseGroupSelect, { value: caseGroupId, onChange: (id) => {
                setCaseGroupId(id);
                setPropertyId('');
            } })),
        h.hasData(propertyTypesLoader) ? (React.createElement(Select, { value: propertyId, onChange: (e) => setPropertyId(e.currentTarget.value) },
            React.createElement("option", { key: "", value: '' }),
            propertyTypesLoader.data
                .filter((propertyType) => propertyType.ref === propertyRef &&
                appliesToCaseGroup(propertyType, caseGroupId))
                .map((propertyType) => {
                return (React.createElement("option", { key: propertyType.propertyTypeId, value: propertyType.propertyTypeId }, propertyType.label));
            }))) : null,
        React.createElement(Button, { disabled: propertyId == '' || value == null, loading: props.loading, onClick: () => {
                if (propertyId == '' || value == null) {
                    return;
                }
                if (propertyRef === Entity.Case || propertyRef === Entity.Customer) {
                    return props.add({
                        propertyRef,
                        overwrite,
                        propertyTypeId: propertyId,
                        value: value,
                    });
                }
                else if (propertyRef === Entity.CaseVoucher) {
                    return props.add({
                        propertyRef,
                        overwrite,
                        propertyTypeId: propertyId,
                        value: value,
                        filter: filter,
                    });
                }
            } }, lang.workflows.addTodo)));
};
//# sourceMappingURL=ProcedureCreator.js.map